export const AppliedTick = ({ fill = '#11A670', ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg fill="none" height="8" viewBox="0 0 10 8" width="10" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M3.49996 6.08492L1.41496 3.99992L0.704956 4.70492L3.49996 7.49992L9.49996 1.49992L8.79496 0.794922L3.49996 6.08492Z"
            fill={fill}
        />
    </svg>
    )
}